import { type ButtonProps as ChakraButtonProps, Icon } from '@chakra-ui/react';

import { useTranslation } from '@oaknorth/util-intl';

import { MdClose } from '../../../icons';
import { IconButton } from '../Button';

export type CloseButtonProps = Omit<ChakraButtonProps, 'children'> & {
  ref?: React.RefObject<HTMLButtonElement | null>;
};

export function CloseButton({ ref, ...props }: CloseButtonProps) {
  const { t } = useTranslation();
  return (
    <IconButton
      variant="ghost"
      aria-label={t`components.core.closeButton.label`}
      ref={ref}
      _hover={{ background: 'blackAlpha.100' }}
      borderRadius="md"
      color="fg"
      {...props}
    >
      <Icon as={MdClose} boxSize={5} />
    </IconButton>
  );
}
